export const messages = {
  en: {
    myResourceStoreManage: {
      queryCondition: 'Query Conditions',
      hide: 'Hide',
      more: 'More',
      enterResId: 'Please enter resource ID',
      enterResName: 'Please enter resource name',
      enterResCode: 'Please enter resource code',
      search: 'Search',
      reset: 'Reset',
      selectResType: 'Please select resource type',
      selectSecondType: 'Please select secondary type',
      selectResSpec: 'Please select resource specification',
      enterUserId: 'Please enter user ID',
      enterUserName: 'Please enter user name',
      selectIsFixed: 'Please select fixed status',
      myResources: 'My Resources',
      return: 'Return',
      transfer: 'Transfer',
      scrap: 'Scrap',
      export: 'Export',
      userId: 'User ID',
      userName: 'User Name',
      resId: 'Resource ID',
      resType: 'Resource Type',
      resName: 'Resource Name',
      resSpec: 'Resource Specification',
      resCode: 'Resource Code',
      isFixed: 'Is Fixed',
      stock: 'Stock',
      miniStock: 'Minimum Stock',
      miniUnit: 'Minimum Unit',
      price: 'Price'
    }
  },
  zh: {
    myResourceStoreManage: {
      queryCondition: '查询条件',
      hide: '隐藏',
      more: '更多',
      enterResId: '请输入物品ID',
      enterResName: '请输入物品名称',
      enterResCode: '请输入物品编码',
      search: '查询',
      reset: '重置',
      selectResType: '请选择物品类型',
      selectSecondType: '请选择二级分类',
      selectResSpec: '请选择物品规格',
      enterUserId: '请输入用户ID',
      enterUserName: '请输入用户名称',
      selectIsFixed: '请选择物品是否固定',
      myResources: '我的物品',
      return: '退还',
      transfer: '转赠',
      scrap: '损耗',
      export: '导出',
      userId: '用户ID',
      userName: '用户名',
      resId: '物品ID',
      resType: '物品类型',
      resName: '物品名称',
      resSpec: '物品规格',
      resCode: '物品编码',
      isFixed: '是否是固定物品',
      stock: '物品库存',
      miniStock: '最小计量总数',
      miniUnit: '最小计量',
      price: '收费标准'
    }
  },
  'zh-TW': {
    myResourceStoreManage: {
      queryCondition: '查詢條件',
      hide: '隱藏',
      more: '更多',
      enterResId: '請輸入物品ID',
      enterResName: '請輸入物品名稱',
      enterResCode: '請輸入物品編碼',
      search: '查詢',
      reset: '重設',
      selectResType: '請選擇物品類型',
      selectSecondType: '請選擇二級分類',
      selectResSpec: '請選擇物品規格',
      enterUserId: '請輸入用戶ID',
      enterUserName: '請輸入用戶名稱',
      selectIsFixed: '請選擇物品是否固定',
      myResources: '我的物品',
      return: '退還',
      transfer: '轉贈',
      scrap: '損耗',
      export: '導出',
      userId: '用戶ID',
      userName: '用戶名',
      resId: '物品ID',
      resType: '物品類型',
      resName: '物品名稱',
      resSpec: '物品規格',
      resCode: '物品編碼',
      isFixed: '是否是固定物品',
      stock: '物品庫存',
      miniStock: '最小計量總數',
      miniUnit: '最小計量',
      price: '收費標準'
    }
  }
}
